'use client';

import classNames from '@sindresorhus/class-names';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {EVENTS} from '@web-landing/analytics/events';

import styles from './VacanciesSiteLink.module.scss';

type Props = {
  text: string;
  url: string;
  variant: 'white' | 'blue';
  className?: string;
};

export const VacansiesSiteLink = ({text, url, variant, className}: Props) => {
  return (
    <a
      target="_blank"
      href={url}
      className={classNames(className, styles[variant], styles.root)}
      onClick={() => {
        logTmrEvent(EVENTS.buttonClick, {button_text: text});
      }}
    >
      {text}
    </a>
  );
};
